import React from "react";

function ErrorPage({ props }) {
  const { idx, message } = props;
  return (
    <div key={idx} className="flex items-center mt-1">
      <img
        src={process.env.REACT_APP_BASE_URL + "/assets/icon/ic_error.svg"}
        alt="icon-error"
        className="h-3 w-auto mr-2"
      />
      <p className="header-content colors-red">{message}</p>
    </div>
  );
}

export default ErrorPage;
